import script from "./ProjectProductsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectProductsList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectProductsList.vue?vue&type=style&index=0&id=468a1e44&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-468a1e44"]])

export default __exports__